import { isMobileOnly } from "react-device-detect";

const SectionTableHeader = ({ showSpec }) => {
  let columns = [
    { label: "No.", width: isMobileOnly ? "10%" : 35 },
    { label: "Name", width: isMobileOnly ? "30%" : 150 },
    { label: "H", width: isMobileOnly ? "10%" : 50 },
    { label: "W", width: isMobileOnly ? "10%" : 50 },
    { label: "D", width: isMobileOnly ? "10%" : 50 },
    { label: "Color", width: isMobileOnly ? "15%" : 60 },
    { label: "Fillers", width: isMobileOnly ? "13%" : 75 },
    { label: "Spec" },
    { label: "Price", width: isMobileOnly ? "15%" : 60 },
  ];

  if (isMobileOnly && showSpec) {
    columns = columns.filter(
      (col) => !["H", "W", "D", "Color"].includes(col.label)
    );
  }

  return (
    <div className="d-flex fw-bold border-top bg-brand-dark text-white">
      {columns.map((column) => {
        if (
          (column.label === "Fillers" && isMobileOnly) ||
          (column.label === "Spec" && !showSpec)
        )
          return null;

        return (
          <div
            key={column.label}
            className={`p-2 border-end border-secondary ${
              !column.width ? "flex-grow-1" : ""
            } ${!isMobileOnly && column.width < 75 ? "text-center" : ""}`}
            style={{
              width:
                typeof column.width === "string"
                  ? column.width
                  : `${column.width}px`,
              flex: "0 0 auto",
            }}
          >
            {column.label}
          </div>
        );
      })}
    </div>
  );
};

export default SectionTableHeader;